/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

import * as ModalActionCreators from '@app/actions/ModalActionCreators';
import RequiredActionModal from '@app/components/modals/RequiredActionModal';
import {resolveRequiredActionFlow} from '@app/components/modals/RequiredActionFlow';
import LayerManager from '@app/stores/LayerManager';
import ModalStore from '@app/stores/ModalStore';
import UserStore from '@app/stores/UserStore';
import {observer} from 'mobx-react-lite';
import React, {useEffect} from 'react';

export const REQUIRED_ACTION_MODAL_KEY = 'required-actions';

const RequiredActionGate = observer(() => {
	const requiredActionKey = resolveRequiredActionFlow(UserStore.currentUser?.requiredActions)?.key ?? null;
	const isModalOpen = ModalStore.hasModal(REQUIRED_ACTION_MODAL_KEY);

	useEffect(() => {
		if (!requiredActionKey) {
			if (isModalOpen) {
				ModalActionCreators.popWithKey(REQUIRED_ACTION_MODAL_KEY);
			}
			return;
		}

		if (!isModalOpen) {
			LayerManager.closeAll();
		}

		ModalActionCreators.pushWithKey(
			ModalActionCreators.modal(() => <RequiredActionModal mock={false} />),
			REQUIRED_ACTION_MODAL_KEY,
		);
	}, [isModalOpen, requiredActionKey]);

	useEffect(
		() => () => {
			ModalActionCreators.popWithKey(REQUIRED_ACTION_MODAL_KEY);
		},
		[],
	);

	return null;
});

export default RequiredActionGate;
